// @flow
import React, { Component } from 'react';
import { View } from 'react-native';
import { ActivityIndicator, Separator } from 'trpc-react-native-ui';
import theme from '../../../../../theme-config';
import ReferralPromotionDetails from '../BonusDetails/ReferralPromotionDetails';
import ActivationBonusDetails from '../BonusDetails/ActivationBonusDetails';
import PromotionCodeDetails from '../BonusDetails/PromotionCodeDetails';
import I18n from '../../../../../lib/i18n';
import FormatService from '../../../../../lib/format';
import type { GodchildBonusType } from 'digicel-kaizen-library';
import { formatGodchildBonuses } from '../../../../../lib/bonuses';

class BonusDetails extends Component<Props> {
  render() {
    const promotionCode = this.props.promotionCode;
    const hasPromotionCode = !!promotionCode && promotionCode !== '';
    const hasPromoSubscriptions = !!this.props.subscriptions && !!this.props.subscriptions.promo;

    if (this.props.isVerifyingBonuses) {
      return <ActivityIndicator color={theme.primaryColor} />;
    }

    if (!this.props.shouldBenefitFromActivationBonus && !this.props.shouldShowGodfather && !hasPromotionCode) {
      return null;
    }

    return (
      <View>
        <View>
          {this.props.shouldBenefitFromActivationBonus && (
            <ActivationBonusDetails
              amount={FormatService.formatCentsToCurrency(this.props.activationBonusAmount)}
              isNotFirstSubscription={this.props.isNotFirstSubscription}
            />
          )}
          {this.props.shouldShowGodfather && this.props.referralPromotion && (
            <ReferralPromotionDetails
              bonus={formatGodchildBonuses(this.props.referralPromotion)}
              confirmPlanType={this.props.confirmPlanType}
              godfatherValidityError={this.props.godfatherValidityError}
              isDiscount={this.props.isReferralPromotionDiscount}
              priceEligibilityError={
                !!this.props.referralPromotion?.price &&
                this.props.isReferralPromotionDiscount &&
                this.props.price > 0 &&
                this.props.price <= this.props.referralPromotion.price
              }
            />
          )}
          {hasPromotionCode && <PromotionCodeDetails code={this.props.promotionCode} />}
          {!hasPromotionCode && hasPromoSubscriptions && !this.props.shouldShowGodfather && (
            <PromotionCodeDetails
              code={this.props.subscriptions && this.props.subscriptions.promo.code}
              isInvalid={true}
              customSubtitle={I18n.t('error.validation.promoCodeHaveExpired')}
            />
          )}
        </View>
        <Separator noMargin />
      </View>
    );
  }
}

export type Props = {
  confirmPlanType: string,
  isReferralPromotionDiscount: boolean,
  isNotFirstSubscription: boolean,
  referralPromotion: ?GodchildBonusType,
  price: number,
  shouldShowGodfather: boolean,
  activationBonusAmount: number,
  isVerifyingBonuses: boolean,
  godfatherValidityError: ?string,
  shouldBenefitFromActivationBonus: boolean,
  promotionCode: ?string,
  subscriptions: ?Object,
};

export default BonusDetails;
